import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { languagePathBuilder } from '@features/auth/shared/languages';
import { TranslocoModule, provideTranslocoScope } from '@ngneat/transloco';
import { NgbActiveModal } from '@shared/components/lib-ng/lib-ng-bootstrap/modal/modal-ref';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslocoModule],
  providers: [provideTranslocoScope('auth')],
  selector: 'app-change-phone-success',
  templateUrl: './change-phone-success.component.html',
  styleUrls: ['./change-phone-success.component.css'],
})
export class ChangePhoneSuccessComponent implements OnInit {
  public activeModal = inject(NgbActiveModal);

  LANUGAGE = languagePathBuilder([
    'component',
    'account',
    'formPhone',
  ]);
  ngOnInit() {}
}
